// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"0417566b","885":"ac7149b7"}[chunkId] + ".chunk.js";
};